export type DataSource = "mock" | "api";

function readDataSource(): DataSource {
  const value = import.meta.env.VITE_DATA_SOURCE?.trim().toLowerCase();
  if (value === "api" || value === "mock") return value;
  return "mock";
}

function readApiBaseUrl(): string {
  return (import.meta.env.VITE_API_BASE_URL ?? "").trim().replace(/\/$/, "");
}

const dataSource = readDataSource();
const apiBaseUrl = readApiBaseUrl();

if (dataSource === "api" && !apiBaseUrl) {
  console.error(
    "[meridian-motors] VITE_DATA_SOURCE=api requiere VITE_API_BASE_URL. Revisa tu archivo .env.",
  );
}

export const env = {
  dataSource,
  apiBaseUrl,
  isApi: dataSource === "api",
  isMock: dataSource === "mock",
} as const;
